// TODO 1727: query recommendations/metrics

import { graphql } from '@/__generated__';
import { useCacheMonitor } from '@/context/DiscoveryUrqlProvider';
import { useQueryStable } from '../useQueryStable';

export const GetEnvironmentMetrics = graphql(/* GraphQL */ `
  query EnvironmentMetrics($environmentId: BigInt!) {
    recommendations(environmentId: $environmentId) {
      lastUpdatedAt
      metrics {
        name
        value
      }
    }
  }
`);

type EnvironmentMetricsParams = {
  environmentId: number | undefined;
  pause?: boolean;
};

export const useEnvironmentMetrics = ({
  environmentId = 0,
  pause,
}: EnvironmentMetricsParams) => {
  const query = useQueryStable({
    query: GetEnvironmentMetrics,
    variables: { environmentId },
    pause: pause || !environmentId,
  });

  useCacheMonitor({ applied: query[0].data?.recommendations.lastUpdatedAt });

  return query;
};
